/**
 * @class
 * @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();

      this.collectionCache = new Map();
    }

    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');

        if (!sectionHeader) return;

        const links = sectionHeader.querySelectorAll('.linked-to-tab');

        this.target = this.dataset.target;
        this.themeScroll = sectionHeader.nextElementSibling;

        const slider = document.getElementById(this.target);

        if (!slider) return;

        /* Cache the initially rendered collection */
        const initialProducts = Array.from(
          slider.querySelectorAll('.collection-tabs--product')
        );

        if (initialProducts.length) {
          const initialHandle =
            initialProducts[0].dataset.collection;

          if (initialHandle) {
            this.collectionCache.set(
              initialHandle,
              initialProducts.map(product => product.cloneNode(true))
            );
          }
        }

        buttons.forEach((button, i) => {
          button.addEventListener('click', event => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);

            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }

            event.preventDefault();
          });
        });

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', event => {
            const index = buttons.indexOf(event.target);

            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    toggleButtons(buttons, index) {
      buttons.forEach(button => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (!links.length) return;

      links.forEach(link => link.classList.remove('active'));

      if (links[index]) {
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);

      if (!slider) return;

      /*
       * Remove the currently mounted products.
       * Templates stay untouched.
       */
      slider
        .querySelectorAll('.collection-tabs--product')
        .forEach(product => product.remove());

      let nodes = [];

      /*
       * Collection already visited / initial collection.
       */
      if (this.collectionCache.has(handle)) {
        nodes = this.collectionCache
          .get(handle)
          .map(node => node.cloneNode(true));
      } else {
        /*
         * First visit to this tab:
         * clone its products from the inert template.
         */
        const template = slider.querySelector(
          `template[data-collection-template="${handle}"]`
        );

        if (!template) return;

        nodes = Array.from(
          template.content.querySelectorAll('.collection-tabs--product')
        ).map(node => node.cloneNode(true));

        /*
         * Cache it so future visits don't need to inspect template again.
         */
        this.collectionCache.set(
          handle,
          nodes.map(node => node.cloneNode(true))
        );
      }

      /*
       * Mount ONLY this collection.
       */
      nodes.forEach(node => {
        node.classList.add('carousel__slide');
        slider.appendChild(node);
      });

      /*
       * Reinitialize existing theme carousel.
       */
      if (this.themeScroll && typeof this.themeScroll.init === 'function') {
        this.themeScroll.init();
      }

      const inner =
        this.themeScroll &&
        this.themeScroll.querySelector('.theme-scroll--inner');

      if (inner) {
        inner.scroll({
          top: 0,
          left: 0
        });
      }
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}